import BaseEntity from './BaseEntity'
import createVideo from './Video'
import createSteps from './Step'

const Props = {
  id: undefined,
  title: undefined,
  description: undefined,
  createdTime: undefined,
  video: undefined,
  steps: undefined,
}

class Curriculum extends BaseEntity {
  constructor(params) {
    super(params)
    this.video = createVideo(params.video || {})
    this.steps = createSteps(params.steps || [])
  }
}

export default function createCurriculum(params) {
  const attr = Object.assign({}, Props, params)
  return Object.freeze(new Curriculum(attr))
}
